import React, { useState, useImperativeHandle, forwardRef, useEffect } from 'react'
import Api from '../../_helpers/Api'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../_providers/Translation'
import NoDataFound from '../partials/NoDataFound'

import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

function ActivityLogView(props, ref) {

    const [state, setState] = useState({
        overlay: false,
        modal: false,
        loading: false,
        id: null,
        data: {
            event: null,
            items: [],
        },
        onClose: null,
    })

    useImperativeHandle(ref, () => ({
        open: id => {
            handleOpen(id)
        },
        close: () => {
            handleClose()
        },
        onClose: fn => {
            setState(prev => ({
                ...prev,
                onClose: fn,
            }))
        },
    }))

    useEffect(() => {
        if (!state.overlay || !state.id) {
            return
        }

        setState(prev => ({
            ...prev,
            loading: true,
        }))

        Api.get('activities/details', {
            params: {
                id: state.id,
            },
        })
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: {
                        event: res.data?.event || null,
                        items: res.data?.items || [],
                    },
                    loading: false,
                }))
            })
            .finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                }))
            })
    }, [state.id, state.overlay])

    const handleOpen = id => {
        setState(prev => ({
            ...prev,
            overlay: true,
            loading: true,
            id: id,
            data: {
                event: null,
                items: [],
            },
        }))

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                modal: true,
            }))
        }, 50)
    }

    const handleClose = e => {
        if (e) e.preventDefault()

        setState(prev => ({
            ...prev,
            modal: false,
        }))

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                overlay: false,
                id: null,
                data: {
                    event: null,
                    items: [],
                },
                onClose: null,
            }))
        }, 50)

        if (typeof state.onClose === 'function') {
            state.onClose()
        } else if (typeof props.onClose === 'function') {
            props.onClose()
        }
    }

    const renderValue = value => {
        if (value === null || value === undefined || value === '') {
            return '-'
        }

        if (typeof value === 'object') {
            return JSON.stringify(value)
        }

        return value
    }

    const renderRows = () => state.data.items.map((row, index) => (
        <tr key={index}>
            <td>{renderValue(row.name)}</td>
            {state.data.event === 'updated'
                ?
                <>
                    <td>{renderValue(row.old)}</td>
                    <td className="center">&rarr;</td>
                    <td>{renderValue(row.new)}</td>
                </>
                :
                <td>{renderValue(row.new)}</td>
            }
        </tr>
    ))

    return (
        <div className={`${state.overlay ? 'visible' : ''} overlay`}>

            <div className={`${state.modal ? 'show' : ''} large popup-primary`}>

                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.viewActivity')}
                        </h2>
                        <p>{trans('subheadings.viewActivity')}</p>
                    </div>
                    <span className='close' onClick={handleClose}>

                    </span>
                </div>

                {state.loading
                    ?
                    <Skeleton height={45} count={5} />
                    :
                    state.data.items.length === 0
                        ?
                        <NoDataFound />
                        :
                        <div className="table-scroller">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{trans('api.parameters')}</th>
                                        {state.data.event === 'updated'
                                            ?
                                            <>
                                                <th>Стара стойност</th>
                                                <th className="center"></th>
                                                <th>Нова стойност</th>
                                            </>
                                            :
                                            <th>{trans('value')}</th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderRows()}
                                </tbody>
                            </table>
                        </div>
                }

                <div className="footer align-right">
                    <button onClick={handleClose}>
                        {trans('buttons.close')}
                    </button>
                </div>

            </div>
        </div>
    )
}

export default React.memo(forwardRef(ActivityLogView))
